/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = require('quill');

module.exports = require('./component');
module.exports.Quill = Quill;
module.exports.Mixin = require('./mixin');
module.exports.Toolbar = require('./toolbar');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-quill/lib/index.js
 ** module id = 634
 ** module chunks = 0
 **/